<ng-container *ngIf="secondaryText | isAnonymous">
   {{ 'common.calling.unknown_number' | translate }}
</ng-container>
<ng-container *ngIf="!(secondaryText | isAnonymous)">
   <ng-container *ngIf="primaryText && secondaryText">
      <span [innerHTML]="primaryText | highlightText$: searchValue | async"> </span>
      <span *ngIf="secondaryText">&nbsp;(</span>
      <span
         [ngClass]="{ callable: isCallable }"
         [innerHTML]="secondaryText | highlightText$: searchValue | async"
      ></span>
      <span *ngIf="secondaryText">)</span>
   </ng-container>
   <ng-container *ngIf="!primaryText || !secondaryText">
      {{ primaryText }} <span [ngClass]="{ callable: isCallable }">{{ secondaryText }}</span>
   </ng-container>
</ng-container>
